/**
 * useAuth hook
 * Convenient access to the AuthContext
 */

import { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'

/**
 * Hook to access authentication state and methods
 * @returns {Object} Auth context value containing:
 * - user: Current Supabase user object
 * - profile: User profile from profiles table
 * - loading: Boolean indicating if auth is loading
 * - session: Current Supabase session
 * - isAuthenticated: Boolean indicating if user is logged in
 * - isAdmin: Boolean indicating if user has admin role
 * - signUp: Function to sign up with email/password
 * - signIn: Function to sign in with email/password
 * - signInWithProvider: Function for OAuth sign in
 * - signOut: Function to sign out
 * - updateProfile: Function to update user profile
 * - getAccessToken: Function to get current access token
 * - refreshProfile: Function to refresh profile data
 */
export default function useAuth() {
    const context = useContext(AuthContext)

    if (context === null) {
        throw new Error('useAuth must be used within an AuthProvider')
    }

    return context
}
